export const TEMP_MAP_CENTER = {
  lat: 51.0525673,
  lng: -114.0717057,
}

export const RIC_DEVICES = [
  // { lat: -34.397, lng: 150.644 },
  // { lat: -34.21, lng: 152.644 },
  // { lat: -32.97, lng: 148.644 },
  // { lat: -32.397, lng: 149.284 },

  {
    deviceName: 'RICProto001',
    deviceSite: 'Beddington',
    location: location(51.130744, -114.0928293),
  },
  {
    deviceName: 'RICProto002',
    deviceSite: "Scott's Home",
    location: location(51.026607513428, -114.12775421143),
  },
  {
    deviceName: 'RICProto003',
    deviceSite: 'ARTC-3 (Edgemont)',
    location: location(51.13187789917, -114.15043640137),
  },
  {
    deviceName: 'RICProto004',
    deviceSite: 'Sunridge',
    location: location(51.0728958, -113.9950437),
  },
  {
    deviceName: 'RICProto005',
    deviceSite: 'Southport',
    location: location(51.0265953, -113.9857204),
  },
  {
    deviceName: 'RICProto006',
    deviceSite: 'Oakridge',
    location: location(50.9781128, -114.0729971),
  },
  {
    deviceName: 'RICProto007',
    deviceSite: 'Beltline',
    location: location(51.0334595, -114.063597),
  },

  {
    deviceName: 'RICProto008',
    deviceSite: 'Sundance',
    location: location(50.896705, -114.0372002),
  },
  {
    deviceName: 'RICProto009',
    deviceSite: 'Mahogany',
    location: location(50.8930057, -113.9596011),
  },
  {
    deviceName: 'RICProto010',
    deviceSite: 'Springbank',
    location: location(51.0237146, -114.2128218),
  },
]

function location(lat: number, lng: number) {
  return {
    lat,
    lng,
  }
}
